export default __webpack_public_path__ + "static/media/notFound.065187f5.jpg";